console.log( 'powering up...' );

$(document).ready(function(){
  $('.mycustomsa__carousel').slick({ 
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 2,
    arrows: false,
    autoplay: true
  });
});

setTimeout( () => {
  console.log( 'ready!' );
  const tabs = document.querySelectorAll( '.pplr_tab_index' );

  let tab_feature_1 = document.querySelector( '.mycustomsa__js--custom-features-1' );
  let tab_feature_2 = document.querySelector( '.mycustomsa__js--custom-features-2' );
  let tab_feature_3 = document.querySelector( '.mycustomsa__js--custom-features-3' );
  let tab_feature_4 = document.querySelector( '.mycustomsa__js--custom-features-4' );

  
  tabs.forEach( ( tab, i ) => {
   if ( tab ) {
     tab.addEventListener( 'click', ( e ) => {
       console.log( tab.getAttribute( 'data-tab' ) );
       switch( tab.getAttribute( 'data-tab' ) ) {
         case '1':
           // console.log('the',tab_feature_2.style);
           tab_feature_1.style.display = "block"; 
           tab_feature_2.style.display = "none"; 
           tab_feature_3.style.display = "none"; 
           tab_feature_4.style.display = "none"; 
           break;
         case '5':
           tab_feature_1.style.display = "none"; 
           tab_feature_2.style.display = "block"; 
           tab_feature_3.style.display = "none"; 
           tab_feature_4.style.display = "none"; 
           break;
         case '7':
           tab_feature_1.style.display = "none"; 
           tab_feature_2.style.display = "none"; 
           tab_feature_3.style.display = "none"; 
           tab_feature_4.style.display = "block"; 
           break;
         case '8':
           tab_feature_1.style.display = "none"; 
           tab_feature_2.style.display = "none"; 
           tab_feature_3.style.display = "block"; 
           tab_feature_4.style.display = "none"; 
           break;
           
       }
     } ); 
   }
    console.log(tab.classList );

    const data_tab = tab.getAttribute( 'data-tab' );
    
    console.log(tab.innerText, data_tab);
  } );

// MYCUSTOMSA PRODUCT TWO  
const section_contact_us_form = document.querySelector( '.contact' ).parentNode;
section_contact_us_form.style.display = 'none'; 
  
const intro_card = document.querySelector( '.js--mycustomsa__custom-intro_card' );
const button_starts_now = document.querySelector( '.js--mycustomsa-customizer--button-starts_now' );

const button_prev = document.querySelector('.js--mycustomsa-customizer--button-prev');
const button_next = document.querySelector('.js--mycustomsa-customizer--button-next');

const current_custom_step = document.querySelector( '.js--mycustomsa-customizer--step-number' );
const custom_step_title = document.querySelector( '.js--mycustomsa-customizer--step-title' );
const total_custom_steps = document.querySelector( '.js--mycustomsa-customizer--step-total' );
const steps_left_custom_steps = document.querySelector( '.js--mycustomsa-customizer--steps-left' );
 
const panes = document.querySelectorAll( '.pplr-wrapper' );  
// const panes = document.querySelectorAll( '.pplr_tab_wrapper' );  
const edu_cards = document.querySelectorAll( '.mycustomsa__custom-features_two' );
const feature_titles = document.querySelectorAll( '.mycustomsa__custom-features_title' );
console.log( 'panes: ', panes.length );
console.log( 'cards: ', edu_cards.length );
console.log( 'titles: ', feature_titles.length );
const container_contact_us = document.querySelector( '.js--mycustomsa__need-help-hide-form' );
const button_contact_us = document.querySelector( '.js--mycustomsa-customizer--contact-us' );

// if contact us button exists...
if ( button_contact_us ) {
  // ...on the click event...
  button_contact_us.addEventListener( 'click', ( e ) => {
    e.preventDefault();
    console.log( 'show form' );
    // ...hide the contact us card...
    container_contact_us.style.display = 'none';
    // ...display the contact form
    section_contact_us_form.style.display = 'block';
  } ); 
}  

// START
  if ( edu_cards ) {
    edu_cards[0].style.setProperty( 'display', 'block' );
  }
// END


// function to display the product builder pane based on the index
const function_display_pane = ( n ) => {
  // for each customizable feature's title...
  feature_titles.forEach( ( title, i ) => {
    // ...if the title's index does not match the n parameter... 
    if ( i != n ) {
      // ...do nothing...
    // ...otherwise...
    } else {
      // ...assign the title for the title of the step
      if ( custom_step_title ) {
      custom_step_title.innerHTML = title.innerHTML;
      }
    }
  } );
  
  // for each education card...
  edu_cards.forEach( ( card, i ) => {
    // ...if the card's index does not match the n parameter... 
      if ( i != n ) {
        // ...hide the card...
        // card.style.display = "none";
      // ...otherwise...
      } else {
        // ...display the card
        card.style.display = "block";
      }
    } );
  
  // for eacn customizable feature pane...
  panes.forEach( ( pane, i ) => {
    // ...if the pane's index does not match the n parameter... 
    if ( i != n ) {
      // ...hide the pane...
      // pane.style.display = "none";
      // ...hide the education card at the index...
      edu_cards[i].style.display = "none";
    // ...otherwise...
    } else {
      // ...display the education card...
      edu_cards[i].style.display = "block";
      // ...display the customizable feature pane
      pane.style.display = "block";
    }
  } );
  
};

// define count_index 
let count_index = 0;

// function for previous button action
const function_prev_button = ( arr ) => {
  // if count_index is greater than 0...
  if (count_index > 0){
    // ...subtract 1 from count_index...
    count_index--;
  }
  console.log( 'current step: ', count_index );
  // ...assign the count_index + 1 to the current step HTML element...
  current_custom_step.innerHTML = count_index + 1;
  
  console.log( 'steps away: ', panes.length - ( count_index ) );
  steps_left_custom_steps.innerHTML = panes.length - ( count_index );
  
  // ... call display pane function with current index
  // function_display_pane( count_index );
};

// function for nex button action
const function_next_button = ( arr, limit ) => {
  // if count_index is less than the limit
  if ( count_index < limit ) {
    // ...add 1 to count_index...
    count_index++;      
  }
  console.log( 'current step: ', count_index );
  // ...assign the count_index + 1 to the current step HTML element...
  current_custom_step.innerHTML = count_index + 1;
  
  console.log( 'steps away: ', panes.length - ( count_index ) );
  steps_left_custom_steps.innerHTML = panes.length - ( count_index );
  
  // ... call display pane function with current index
  function_display_pane( count_index );
};


// if panes element exists...
if ( panes ) {
  // if the starts now button exists...
  if ( button_starts_now ) {
    // ...on the click event listener...
    button_starts_now.addEventListener( 'click', ( e ) => {
      // ...remove intro card element...
      intro_card.remove();
      // ...display the first education card...
      edu_cards[0].style.display = "block";
      // ...display the first pane...
      panes[0].style.display = "block";
      // ...display product builder nav buttons
      document.querySelector( '.mycustomsa-customizer--button-container' ).style.display = "block";      
    } ); 
  }
  // console.log( 'length: ' + panes.length);
  
  // if total custom steps elements exists...
  if ( total_custom_steps ) {
    // ...assign the panes array length to the total custom steps HTML element
    total_custom_steps.innerHTML = panes.length;
  }
  if ( steps_left_custom_steps ) {
    steps_left_custom_steps.innerHTML = panes.length;
  }
  
  // for each education card...
  edu_cards.forEach( ( card, i ) => {
    console.log(card[i]);
    if ( i > 0 ) {
      // ...hide the card...
      card.style.display = "none";
    }
    // ...if customizable features title element exists...
    if ( feature_titles ) {
      // ...assign the the title to the custom step title 
      if ( custom_step_title ) {
      custom_step_title.innerHTML = feature_titles[0].innerHTML;
      }
    }
  } );
  // for each product builder pane...
  panes.forEach( ( pane, i ) => {
    //if ( i > 0 ) {
      // pane.style.display = "none";
    //} 
    // ...if the screen width is less than 750...
    if ( screen.width < 750 ) {
      // ...if the index is greater than 0...
      if ( i > 0 ) {
        // ...hide the pane
        // pane.style.display = "none";
      }
    };
  } );

  // if the previous button element exists...
  if ( button_prev ) {
    // ...on the click event listener...
    button_prev.addEventListener( 'click', ( e ) => {
      // ...call the previous button function
      function_prev_button( panes );
    } );
  }
  // if the next button element exists...
  if ( button_next ) {
    // ...on the click event... 
    button_next.addEventListener( 'click', ( e ) => {
      // ...call the next button function
      function_next_button( panes, panes.length - 1 );
    } );
  }
  
  const button_form_add_to_cart = document.querySelector( '.product-form__submit' );
  const button_form_payment = document.querySelector( '.shopify-payment-button__button' );
  const pplr_from = document.querySelector( '.product-form__buttons' );
  if ( button_form_add_to_cart ) {
    // console.log( 'add to cart: ', button_form_add_to_cart );
    button_form_add_to_cart.addEventListener( 'click', ( e ) => {
      console.log('hi');
    } );
  }
  if ( button_form_payment ) {
    // console.log( 'form payment: ', button_form_payment );
    button_form_payment.addEventListener( 'click', ( e ) => {
      console.log('hi');
    } );
  }
  pplr_from.addEventListener( 'onchange', ( e ) => {
    console.log('yes');
  } );

  
// window.addEventListener('pplrAddToCartCompleted' , function(e) {
//   console.log( 'hi' );
// });  
}

}, 1000 );